import Page from './[...path]';

export default Page;
